import styled from '@emotion/styled';

// components
import Typography from '@components/_atoms/Typography';

// constants
import { TypoVariant } from '@constants/atoms';
import { gray, primary, red } from '@styles/Colors';
import { useTranslation } from 'next-i18next';

const Layout = styled.div`
  padding: 16px 10px;
  border-bottom: 1px solid ${gray.gray4};

  display: grid;
  column-gap: 24px;
`;

const TotalPriceText = styled.div``;

export default function TableLabel() {
  const { t } = useTranslation('seller');
  const gridTemplateColumns = '48px 1fr 80px 120px 120px 24px';

  return (
    <Layout style={{ gridTemplateColumns }}>
      <Typography variant={TypoVariant.SH3} color={primary.gray}>
        No.
      </Typography>
      <Typography variant={TypoVariant.SH3} color={primary.gray}>
        {t('reRequest.description')}
      </Typography>
      <Typography variant={TypoVariant.SH3} color={primary.gray}>
        {t('reRequest.quantity')}
      </Typography>
      <Typography variant={TypoVariant.SH3} color={primary.gray}>
        {t('reRequest.unitPrice')}
      </Typography>
      <TotalPriceText>
        <Typography variant={TypoVariant.SH3} color={primary.gray}>
          {t('reRequest.totalPrice')}
        </Typography>
        <Typography variant={TypoVariant.B4} color={red.red3}>
          {t('reRequest.vat-except')}
        </Typography>
      </TotalPriceText>
    </Layout>
  );
}
